export default "__VITE_ASSET__71c618d5__"